// On-device face/person scanning is INVISIBLE to users. The meaningful progress is the content
// upload; scanning runs on a decoupled track (and falls back to a server scan on any failure), so
// we never surface its progress in the uploader UI. A job that has finished uploading but is still
// scanning reads as "done" for display. Flip SHOW_SCAN_PROGRESS to true only to debug the scan UI.

import { isScanAdmin } from "./scanAdmin";

export const SHOW_SCAN_PROGRESS = false;

// Map a job/session phase to what the UI should show. When scan progress is hidden, a "scanning"
// job (content already uploaded) presents as "done".
export const displayPhase = (phase: string): string =>
  !SHOW_SCAN_PROGRESS && phase === "scanning" ? "done" : phase;

// The on-device-scan debug surface — the metrics strip / levers AND the console
// logging — is visible ONLY to andy@photohawk.io (isScanAdmin). Everyone else NEVER
// sees it. Andy can silence it per-browser with localStorage ph_scan_debug = "0".
// NOT cached: the admin verdict is pushed in after auth resolves, so a cached "false"
// from the first paint would wrongly stick. Both the UI gate and the log gate share
// this — the whole surface is andy-only.
const debugAvailable = (): boolean => {
  if (!isScanAdmin()) return false;
  try {
    const flag = typeof localStorage !== "undefined" ? localStorage.getItem("ph_scan_debug") : null;
    return flag !== "0" && flag !== "false"; // andy: on unless explicitly silenced
  } catch {
    return true;
  }
};

// UI gate for the scan levers/metrics overlay (andy-only).
export const scanDebugEnabled = debugAvailable;

// Console logging for the (invisible) on-device scan track (andy-only, console-only).
export const scanLogEnabled = debugAvailable;

// Namespaced console logger for the scan track; a no-op unless scanLogEnabled().
export const scanLog = (...args: unknown[]): void => {
  if (!scanLogEnabled()) return;
  // eslint-disable-next-line no-console
  console.log("[photohawk scan]", ...args);
};
